import type { KnowledgeItem } from "../data/schemas.js";

export type KnowledgeTriggerReason = "step_entered" | "wrong_answer" | "hint_requested";

export function findKnowledge(items: KnowledgeItem[], id: string): KnowledgeItem | undefined {
  return items.find((item) => item.id === id);
}

export function showKnowledge(
  items: KnowledgeItem[],
  id: string,
): { item: KnowledgeItem } | undefined {
  const item = findKnowledge(items, id);
  return item ? { item } : undefined;
}
